<template>
  <div class="vg_wrapper">
    <el-card>
      <el-row>
        <el-col :md="24">
          <el-button class="vg_mb_8" size="small" type="info" @click="buttonRefresh()">刷新</el-button>
          <SearchTable
            ref="multiTable"
            v-loading="loading"
            :columns="[
              { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
              { label: '提醒时间', prop: 'create_time', input: false, itemType: 'input', formatter: val => (val ? helper.toTime(val) : '暂无') },
              { label: '提醒消息', prop: 'message', input: false, itemType: 'input' },
              { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false }
            ]"
            :data="tableData"
            :need-check-box="false"
            :need-fixed-height="true"
            :need-pagination="false"
            :need-search="false"
            :tableRowKey="'id'"
            @getTableData="getPushList"
          >
            <template v-slot:operation="scope">
              <el-link class="vg_mr_8" type="success" @click="operation(scope.row)">查看详情</el-link>
            </template>
          </SearchTable>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { cloneDeep } from 'lodash';
import helper from '@assets/js/helper';
import { api } from './js/api';

export default {
  name: 'OverseasConsultationFormV2Push9012',
  components: { SearchTable },
  data() {
    return {
      tableData: [],
      loading: true,
      isEditObj: [],
      multiSelection: []
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getPushList();
    },
    // 多选
    handleSelectionChange(val) {
      this.multiSelection = val;
    },
    // 刷新
    buttonRefresh() {
      this.$refs.multiTable.resetFields();
      this.getPushList();
    },
    //获取信息
    getPushList() {
      this.loading = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      searchForm.user_id = this.$cookies.get('userInfo').user_id;
      api.getPush9012List(searchForm).then(({ data }) => {
        this.loading = false;
        this.tableData = data;
      });
    },
    // 从提醒消息文本中解析打样单号和品名
    getRouteQuery(row) {
      const message = (row.message || '').replace(/<[^>]+>/g, '');
      const match = message.match(/打样单号[：:]\s*(.*?)\s*品名[：:]\s*(.*?)(?:请上传资料并回传|$)/);
      return {
        sampling_order_number: match ? match[1].trim() : '',
        prod_name: match ? match[2].trim() : ''
      };
    },
    operation(row) {
      api.editPush9012(row).then(({ data }) => {
        this.buttonRefresh();
        this.jump('/consultationsv2_list?perm_id=146', this.getRouteQuery(row));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.vd_completed {
  color: $color-secondary-text;
}
</style>
